//Home.js
import { useEffect, useState } from "react";
import Navbar from "../components/MainNavbar";
import { TSongSheet } from "../types/SongSheet";
import {
  GetSongSheetByFolder,
  GetSongSheetByTags,
} from "../services/SongSheet";
import { toast } from "react-toastify";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBold,
  faBolt,
  faHourglassHalf,
  faLightbulb,
} from "@fortawesome/free-solid-svg-icons";

const Home = () => {
  const [popular, setPopular] = useState<TSongSheet[]>([]);
  const [wipSongs, setWipSongs] = useState<TSongSheet[]>([]);
  const [ideasSongs, setIdeasSongs] = useState<TSongSheet[]>([]);

  useEffect(() => {
    GetSongSheetByFolder(
      "popular",
      (res: any) => {
        setWipSongs(res.data.songSheets);
      },
      (err: any) => {
        toast.error(err);
      }
    );

    GetSongSheetByFolder(
      "wip",
      (res: any) => {
        setWipSongs(res.data.songSheets);
      },
      (err: any) => {
        toast.error(err);
      }
    );

    GetSongSheetByFolder(
      "ideas",
      (res: any) => {
        setIdeasSongs(res.data.songSheets);
      },
      (err: any) => {
        toast.error(err);
      }
    );
  }, []);

  return (
    <div>
      <Navbar />
      <h1>Connection sting: {process.env.REACT_APP_API_URL}</h1>
      <div className="mainContainer">
        <div className="list">
          <h2>
            <FontAwesomeIcon icon={faBolt} /> Popular
          </h2>
          <ul>
            {popular?.map((item) => (
              <li>
                <span>
                  <NavLink
                    className={({ isActive }) =>
                      isActive ? "active" : "inactive"
                    }
                    to={`/songs/${item._id}`}
                  >
                    {item.artist} - {item.name}
                  </NavLink>
                </span>
              </li>
            ))}
          </ul>
        </div>

        <div className="list">
          <h2>
            <FontAwesomeIcon icon={faHourglassHalf} /> Work in Progress
          </h2>
          <ul>
            {wipSongs?.map((item) => (
              <li>
                <span>
                  {" "}
                  <NavLink
                    className={({ isActive }) =>
                      isActive ? "active" : "inactive"
                    }
                    to={`/songs/${item._id}`}
                  >
                    {item.artist} - {item.name}
                  </NavLink>
                </span>
              </li>
            ))}
          </ul>
        </div>

        <div className="list">
          <h2>
            <FontAwesomeIcon icon={faLightbulb} /> Ideas
          </h2>
          <ul>
            {ideasSongs?.map((item) => (
              <li>
                <span>
                  {" "}
                  <NavLink
                    className={({ isActive }) =>
                      isActive ? "active" : "inactive"
                    }
                    to={`/songs/${item._id}`}
                  >
                    {item.artist} - {item.name}
                  </NavLink>
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Home;
